/**
 * Portal main
 *
 * Portal main acts as the consolidator for all of the portal application tools. It initializes the
 * application by generating and storing the objects needed. This includes the token object, and
 * controllers being used.
 */



// the constructor for this object
function MyPortalMain() {

    // this allows touch events to work for hover
    $('body').bind('touchstart', function() {});

    // prevent links being clicked if disabled
    $('a').click(function(e) {
        if ($(this).is('[disabled]')) {
            e.preventDefault();
        }
    });

    var portalMobileMenu = function(){
        $("#mobile-menu-toggle").click(function(){
            $(".sidebar-col--portal").toggleClass("-open");
        });
        $(window).resize(function(){
            if($(window).width() >= 1024){
                $(".sidebar-col--portal").removeClass("-open");
            }
        });
        $(".portal-mobile-menu-toggles .btn").click(function(){
            $(".sidebar-col--portal").toggleClass("show-portal-menu");
            $(".portal-mobile-menu-toggles .btn").toggleClass("active").blur();
        });
    };
    portalMobileMenu();

    var portalSidebarScroll = function() {
        var topCatch = $("#portal-sidebar-top-catch");
        var bottomCatch = $("#portal-sidebar-bottom-catch");
        var sidebar = $("aside.sidebar-col--portal");
        var stickySidebar = $("#portal-sidebar-sticky-wrap");
        var lastScrollTop = 0;
        var windowHeight = $(window).height();
        $(window).scroll(function(){
            if($(window).width() >= 1024 && sidebar.outerHeight() > (stickySidebar.outerHeight() * 1.5)){
                var st = $(this).scrollTop();
                if (st > lastScrollTop){
                    // downscroll code
                    if((bottomCatch).filter(":in-viewport").length){
                        var top = ((st + windowHeight) - (stickySidebar.outerHeight() + sidebar.offset().top)) - 30;
                        if(top > 0 && top < (sidebar.outerHeight() - stickySidebar.outerHeight())){
                            stickySidebar.addClass("down-sticky");
                            stickySidebar.removeClass("up-sticky");
                            stickySidebar.css({
                                'top': top,
                            });
                        }
                    }
                } else {
                    // upscroll code
                    if((topCatch).filter(":in-viewport").length){
                        var top = (st - sidebar.offset().top) + 30;
                        if(top > 0){
                            stickySidebar.addClass("up-sticky");
                            stickySidebar.removeClass("down-sticky");
                            stickySidebar.css({
                                'top': top,
                            });
                        } else {
                            stickySidebar.removeClass("up-sticky down-sticky");
                            stickySidebar.css({
                                'top': '',
                            });
                        }
                    }
                }
                lastScrollTop = st;
            }
        });
    };
    portalSidebarScroll();
}

// the object
MyPortalMain.prototype = {
    constructor: MyPortalMain,

    // store the controller instances here
    _controllers: [],

    // store the controller directory of the uri
    _controllerDirectory: '',

    // store the route segments for use in the page controllers
    _routeSegments: [],

    // if the page controller was found, and the index controller wasn't used by default
    _pageControllerFound: true,

    _authResolver: null,

    onUserReady: null,

    init: function()
    {
        // create a token object
        this.PortalToken = new PortalToken;

        // create a user object
        this.PortalUser = new PortalUser;

        // create an accounts object
        this.PortalAccounts = new PortalAccounts;

        // create a products object
        this.PortalProducts = new PortalProducts;

        // create a resources object
        this.PortalResources = new PortalResources;

        // create a login object
        this.PortalLogin = new PortalLogin;

        // do not initiate controllers if this is not a portal page
        if(!$('#portal-content').length) {
            return;
        }

        // add the primary controller to this object
        this._includeController('PrimaryController');

        // get the controller for the given page
        this._includePageController();

        // break up the controller segments
        this._storeControllerDirectory();

        // break up the route segments
        this._storeRouteSegments();

        // this promise resolves when all auth details are ready (ie, when the login callback is called)
        this.onUserReady = new Promise((resolve) => {
          this._authResolver = resolve;
        });

        // check for login data updates
        PortalMain.PortalLogin.callback = function() {

            // init each controller
            PortalMain._initControllers();

            // handle the chart init
            PortalMain._initCharts();

            // run each controller
            PortalMain._runControllers();

            // this is the goofiest promise I've ever used
            PortalMain._authResolver();
        }
        PortalMain.PortalLogin.checkLoginDataTime();
    },

    // get the route segments from the URI and save them
    _storeRouteSegments: function()
    {
        // get the path and split it into segments
        var windowPath = window.location.pathname.substring(1);
        var segments = windowPath.split('/');

        // remove the portal, and directory segment
        segments.shift();
        segments.shift();

        // remove the controller section if one was found in the uri
        if (this._pageControllerFound) {
            segments.shift();
        }

        // store the segments
        for(var i in segments) {
            if (segments[i]) {
                this._routeSegments.push(segments[i]);
            }
        }
    },

    // get the controller directory from the URI and save it
    _storeControllerDirectory: function()
    {
        // get the path and split it into segments
        var windowPath = window.location.pathname.substring(1);
        var segments = windowPath.split('/');

        this._controllerDirectory = segments[1];
    },

    // return the route segments
    getRouteSegments: function()
    {
        return this._routeSegments;
    },

    // return the controller directory
    getControllerDirectory: function()
    {
        return this._controllerDirectory;
    },

    // add the controller to the object, and store the list to reference
    _includeController: function(controllerName)
    {
        // debug
        if (PortalConfig.debug && typeof window[controllerName] == 'undefined') {
            // eslint-disable-next-line no-console
            console.log('DEBUG: No controller found by the name of ' + controllerName);
        }

        // only include the controller if it actually exists
        if (typeof window[controllerName] !== 'undefined') {
            this[controllerName] = new window[controllerName];
            this._controllers.push(controllerName);
        }
    },

    // add the controller specifically used by the current page
    _includePageController: function()
    {
        // get the directory and uppercase the first letter
        var controllerDirectory = document.getElementById('portal-directory').value;
        controllerDirectory = controllerDirectory.charAt(0).toUpperCase() + controllerDirectory.slice(1);

        // get the controller name and uppercase the first letter
        var controllerName = document.getElementById('portal-controller').value;
        controllerName = controllerName.charAt(0).toUpperCase() + controllerName.slice(1);

        // combine all to the full name
        controllerName = controllerDirectory + controllerName + 'Controller';

        // remove dashes, and uppercase the next character
        controllerName = controllerName.replace(/(-.)/g,function(x){return x[1].toUpperCase()});

        // the controller wasn't found, so use the default index
        if (typeof window[controllerName] == 'undefined') {

            // set this to return the proper route parameters
            this._pageControllerFound = false;

            // remove dashes, and uppercase the next character
            controllerDirectory = controllerDirectory.replace(/(-.)/g,function(x){return x[1].toUpperCase()});

            // set the controller name to the index
            controllerName = controllerDirectory + 'IndexController';
        }

        this._includeController(controllerName);
    },

    // run each controller
    _initControllers: function()
    {
        for (var i in this._controllers) {
            var controllerName = this._controllers[i];
            this[controllerName].init();
        }
    },

    // load the chart libraries, and set the charts as active
    _initCharts: function()
    {
        google.charts.load('current', {'packages':['corechart']});
        google.charts.setOnLoadCallback(function() {
            PortalMain._setAllChartsActive();
        });
    },

    // set each chart as active
    _setAllChartsActive: function()
    {
        // loop through each controller
        for (var i in this._controllers) {
            var controllerName = this._controllers[i];

            // loop through each property and find the ones that are a PortalChart
            for (var property in this[controllerName]) {
                var chart = this[controllerName][property];
                if (chart instanceof PortalChart) {

                    // set the chart as active, and draw it
                    chart.libraryLoaded = true;
                    chart.draw();

                }
            }
        }
    },

    // run each controller
    _runControllers: function()
    {
        for (var i in this._controllers) {
            var controllerName = this._controllers[i];
            this[controllerName].run();
        }
    },

    // redirect the user if they don't have auth rights to access the page
    authRedirect: function()
    {
        if (!PortalMain.PortalToken.getToken()) {
            var redirectUrl = PortalConfig.loginUrl;
            window.location.href = redirectUrl;
        }
    },

    // redirect the user if they don't have uss admin rights to access the page
    ussAdminRedirect: function()
    {
        var user = PortalMain.PortalToken.getPayload();
        if (user.uss_admin_level <= 0) {
            var redirectUrl = PortalConfig.portalUrl + '/home';
            window.location.href = redirectUrl;
        }
    }
}

// This jump starts the Portal
if ( ! $ && jQuery ) {
    var $ = jQuery;
}
var PortalMain = new MyPortalMain;
PortalMain.init();
